import type { ApiService } from '@/core/http/services/ApiService'
import type { AxiosResponse } from 'axios'
import type { MenuResponse } from '@/core/http/services/menu/types'
import type { DataResponse } from '@/core/http/services/types'

export class MenuService {
  constructor(private readonly service: ApiService) {
    //
  }

  index(): Promise<AxiosResponse<DataResponse<MenuResponse>>> {
    return this.service.client.get('/api/frontend/menu')
  }
}
